module.exports = __webpack_public_path__ + "static/img/network-03.1121b55.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/register/network/network-03.jpg
// module id = ae8m
// module chunks = 1